import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { DetalhesMedicaoComponent } from '@app/modules/medicoes/components/detalhes-medicao/detalhes-medicao.component';
import { MedicaoComponent } from '@app/modules/medicoes/pages/medicoes/medicoes.component';
import { MedicoesController } from '@modules/medicoes/controllers';
import { AnimationsModule } from '@shared/animations/animations.module';
import { ComponentsModule } from '@shared/components/components.module';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ReprovarMedicaoComponent } from './components/reprovar-medicao/reprovar-medicao.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [MedicaoComponent, DetalhesMedicaoComponent, ReprovarMedicaoComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), MedicoesController],
})
export class MedicoesModule {}
